import { createAction, union } from '@ngrx/store';
import { HttpRouting } from '@zerops/models/http-routing';

export const httpRoutingEditDialogOpen = createAction(
  '[@zerops/zerops/feature/http-routing-edit-dialog] open',
  (
    httpRouting: Partial<HttpRouting>,
    projectId: string,
    serviceStackId?: string,
    locationPath?: string
  ) => ({ httpRouting, projectId, serviceStackId, locationPath })
);

const all = union({ httpRoutingEditDialogOpen });

export type HttpRoutingEditDialogActionUnion = typeof all;
